<template>
  <Toast />
  <div class="p-grid">
    <div class="p-col-12">
      <Panel header="Gerenciamento de Motoristas">
        <Toolbar class="p-mb-4">
          <template #start>
            <Button label="Novo" icon="pi pi-plus" @click="showCreate()" />
          </template>

          <template #end>
            <div
              class="table-header flex flex-column md:flex-row md:justify-content-between"
            >
              <span class="p-input-icon-left">
                <i class="pi pi-search" />
                <InputText
                  v-model="filters['global'].value"
                  placeholder="Buscar..."
                />
              </span>
            </div>
          </template>
        </Toolbar>
        <DataTable
          :ref="dt"
          :dataKey="id"
          class="p-datatable-sm"
          :value="list"
          :paginator="true"
          :rows="10"
          :rowsPerPageOptions="[10, 20, 30]"
          :filters="filters"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          :loading="loading"
          :totalRecords="totalRecords"
          currentPageReportTemplate="Registro {first} de {last} de um total de {totalRecords} motoristas."
        >
          <template #empty>
            <div class="p-text-center">Nenhum resultado encontrado...</div>
          </template>

          <Column header="Nome" field="name" sortable>
            <template #body="slotProps">
              <div v-if="slotProps.data.name">
                {{ slotProps.data.name }}
              </div>
              <div v-else style="color: red"><b>PENDENTE</b></div>
            </template>
          </Column>
          <Column header="Matrícula" field="credential" sortable> </Column>
          <Column header="CNH" field="cnh" sortable> </Column>
          <Column header="Categoria" field="category" sortable> </Column>
          <Column header="Status" field="status" sortable>
            <template #body="slotProps">
              <span
                :class="'badge status-' + slotProps.data.status"
                @click="changeStatus(slotProps.data)"
                v-tooltip.top="'Clique para alterar Status'"
                style="cursor: pointer"
                >{{ $Util.formatAtivo(slotProps.data.status) }}</span
              >
            </template>
          </Column>
          <Column header="Ações">
            <template #body="slotProps">
              <Button
                icon="pi pi-pencil"
                class="p-button-rounded p-button-success mr-2"
                @click="showUpdate(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA ATUALIZAR'"
              />
              <Button
                icon="pi pi-trash"
                class="p-button-rounded p-button-warning mr-2"
                @click="showRemove(slotProps.data)"
                v-tooltip.top="'CLIQUE PARA REMOVER'"
              />
            </template>
          </Column>
        </DataTable>
      </Panel>
    </div>
  </div>

  <dialog-form :objSelected="obj" @findAll="findAll" />
  <dialog-upload :objSelected="obj" @findAll="findAll"></dialog-upload>

  <ConfirmDialog />
</template>

<script>
import { Status } from "../../models/enums/status";
//models
import Driver from "../../models/internal/driver";
//Services
import DriverService from "../../service/driver/driver_service";
//components
import DialogForm from "./components/dialog-form.vue";
import DialogUpload from "./components/dialog-upload.vue";

export default {
  components: {
    DialogForm,
    DialogUpload,
  },
  data() {
    return {
      loading: false,
      totalRecords: null,
      Status,
      filters: {
        global: {
          value: null,
        },
      },
      list: [],
      obj: new Driver(),
      lazyParams: {},
      service: new DriverService(),
    };
  },
  mounted() {
    this.loading = true;
    this.findAll();
  },
  methods: {
    showCreate() {
      this.obj = new Driver();
      this.$store.state.views.driver.dialogForm = true;
    },
    showUpdate(obj) {
      this.obj = obj;
      this.$store.state.views.driver.dialogForm = true;
    },
    showRemove(obj) {
      this.$confirm.require({
        message: "Deseja Excluir esse registro?",
        header: "Deseja deletar?",
        icon: "pi pi-exclamation-triangle",
        acceptLabel: "Sim",
        rejectLabel: "Não",
        accept: () => {
          this.service
            .delete(obj.id)
            .then((data) => {
              this.$msgSuccess(data);
              this.findAll();
            })
            .catch((error) => {
              this.$msgErro(error);
            });
        },
      });
    },
    findAll() {
      this.loading = true;
      this.service.findAll().then((data) => {
        this.list = data.content;
        this.loading = false;
      });
    },
    changeStatus(obj) {
      this.service.changeStatus(obj.id).then((res) => {
        if (res.status === 204) {
          this.findAll();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
